// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1CqXo","selected":"Chip_selected__1_eEO"};